import styled from "styled-components";
import {StyleDiv} from "../Common/StyleDiv";

export const SignInFormContainer = styled(StyleDiv)`
  width: calc(100% - 750px);
  @media (max-width: 1200px) {
    width: 100%;
  }
`;
